import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bc35922"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-checkbox" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["id", "value", "checked"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_7 = { class: "div-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputError = _resolveComponent("InputError")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: _ctx.nameID,
        class: "label-checkbox"
      }, [
        (_ctx.labelMessage === '')
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.labelMessage != '')
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.labelMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("input", _mergeProps({
          id: _ctx.nameID,
          type: "checkbox",
          class: "checkbox-input"
        }, _ctx.$attrs, {
          value: _ctx.modelValue,
          checked: _ctx.modelValue,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (
                        _ctx.$emit(
                            'update:modelValue',
                            Boolean($event.target.checked)
                        )
                    )),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', $event.target.checked)))
        }), null, 16, _hoisted_5),
        _hoisted_6
      ], 8, _hoisted_2),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createVNode(_component_InputError, { msg: _ctx.errors }, null, 8, ["msg"])
      ], 512), [
        [_vShow, _ctx.isInvalid]
      ])
    ])
  ]))
}